<div class="modal-header" *ngIf="!isAddMode">
    <h4 class="modal-title">Editar elemento</h4>
</div>
<div class="modal-header" *ngIf="isAddMode">
    <h4 class="modal-title">Crear elemento</h4>
</div>
<div class="modal-body">
    <form [formGroup]="form"
          (ngSubmit)="onSubmit()">
        <div class="form-row">
            <div class="form-group col-6">
                <label>Nombre</label>
                <input type="text"
                       formControlName="nombre"
                       class="form-control"
                       [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }" />
                <div *ngIf="submitted && f.nombre.errors"
                     class="invalid-feedback">
                    <div *ngIf="f.nombre.errors.required">First Name is required</div>
                </div>
            </div>
            <div class="form-group col-6">
                <label>Uuid</label>
                <input [disabled]="true"
                       type="text"
                       formControlName="uuid"
                       class="form-control"
                       />
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <ng-multiselect-dropdown [placeholder]="'Select columns'"
                                         [settings]="dropdownSettings"
                                         [data]="extraVar"
                                         formControlName="labels"
                                         (onSelect)="onItemSelect($event)"
                                         (onDeSelect)="onDeSelect($event)">
                </ng-multiselect-dropdown>
            </div>
        </div>
        <!-- Optional fields -->
        <div *ngIf="!isAddMode && showId" class="form-row">
            <div class="form-group col-12">
                <label>id</label>
                <input type="text"
                       formControlName="id"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showTopic" class="form-row">
            <div class="form-group col-12">
                <label>topic</label>
                <input type="text"
                       formControlName="topic"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showGetawayTopic" class="form-row">
            <div class="form-group col-12">
                <label>gatewayTopic</label>
                <input type="text"
                       formControlName="gatewayTopic"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showAddress" class="form-row">
            <div class="form-group col-12">
                <label>address</label>
                <input type="number"
                       formControlName="address"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showIp" class="form-row">
            <div class="form-group col-12">
                <label>ip</label>
                <input type="text"
                       formControlName="ip"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showBaudRate" class="form-row">
            <div class="form-group col-12">
                <label>baudRate</label>
                <input type="number"
                       formControlName="baudRate"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showDataBits" class="form-row">
            <div class="form-group col-12">
                <label>dataBits</label>
                <input type="number"
                       formControlName="dataBits"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showEncoding" class="form-row">
            <div class="form-group col-12">
                <label>encoding</label>
                <input type="text"
                       formControlName="encoding"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showParity" class="form-row">
            <div class="form-group col-12">
                <label>parity</label>
                <input type="text"
                       formControlName="parity"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showPath" class="form-row">
            <div class="form-group col-12">
                <label>path</label>
                <input type="text"
                       formControlName="path"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showStopBits" class="form-row">
            <div class="form-group col-12">
                <label>stopBits</label>
                <input type="number"
                       formControlName="stopBits"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showType" class="form-row">
            <div class="form-group col-12">
                <label>type</label>
                <input type="text"
                       formControlName="type"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showChannel" class="form-row">
            <div class="form-group col-12">
                <label>channel</label>
                <input type="text"
                       formControlName="channel"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showModelo" class="form-row">
            <div class="form-group col-12">
                <label>modelo</label>
                <input type="text"
                       formControlName="modelo"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showPort" class="form-row">
            <div class="form-group col-12">
                <label>port</label>
                <input type="number"
                       formControlName="port"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showTimeout" class="form-row">
            <div class="form-group col-12">
                <label>timeout</label>
                <input type="number"
                       formControlName="timeout"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showWait" class="form-row">
            <div class="form-group col-12">
                <label>wait</label>
                <input type="number"
                       formControlName="wait"
                       class="form-control"/>
            </div>
        </div>
        <div *ngIf="!isAddMode && showHost" class="form-row">
            <div class="form-group col-12">
                <label>host</label>
                <input type="text"
                       formControlName="host"
                       class="form-control"/>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn btn-outline-dark"
            (click)="activeModal.close('Save click');onSubmit()">Guardar</button>
    <button type="button"
            class="btn btn-outline-dark"
            (click)="activeModal.close('Close click')">Cerrar</button>
</div>